import { mutator } from 'satcheljs';
import inboxPlusStore from '../store/Store';
import InboxPlusPivotViewState from '../store/schema/InboxPlusPivotViewState';
import { onPivotEnableDisableDialogSave, bootstrapInboxPlusPivots } from '../actions/publicActions';

mutator(onPivotEnableDisableDialogSave, actionMessage => {
    deepCopyPivotsToStore(actionMessage.pivotsToSet);
});

mutator(bootstrapInboxPlusPivots, actionMessage => {
    deepCopyPivotsToStore(actionMessage.pivotsToSet);
});

function deepCopyPivotsToStore(pivotsToCopy: InboxPlusPivotViewState[]) {
    inboxPlusStore.inboxPlusPivots = pivotsToCopy.map((pivot: InboxPlusPivotViewState) => ({
        ...pivot,
    }));
}
